class ChatModule {
    static chatModules = null;

    static importChatWrapper() {
        if (ChatModule.chatModules) {
            return new Promise(resolve => {
                return resolve(ChatModule.chatModules);
            });
        }
        return import(/* webpackChunkName: "ChatWrapper" */'./ChatWrapper').then(module => {
            ChatModule.chatModules = module;
            return ChatModule.chatModules;
        });
    }

    static instantiateChatWrapper(config, mod) {
        return new Promise(resolve => {
            ChatModule.importChatWrapper().then(({ 'default': ChatWrapper }) => {
                ChatWrapper.instantiateXMPP((module, interventionData, systemMessageData, shouldRefreshData) => {
                    if (shouldRefreshData) {
                        if (interventionData) {
                            module.setInterventionsData(interventionData);
                        }
                        if (systemMessageData) {
                            module.setSystemMessageData(systemMessageData);
                        }
                    }
                    ChatWrapper.loadingPromise.then(() => {
                        ChatWrapper[mod]().then(() => resolve());
                    });
                }, config && config.chat && config.chat.newChat, config.theme && config.theme.id);
            });
        });
    }

    static instantiateChat(config) {
        return ChatModule.instantiateChatWrapper(config, 'importChat');
    }

    static instantiateMyZone(config) {
        return ChatModule.instantiateChatWrapper(config, 'importMyZone');
    }
}

export default ChatModule;
